export enum HubChannel {
  NOTIFICATIONS = 'eclipsenotifications',
  NEW_FEEDBACK = 'mcfeedbacknew',
  DREAMSOFART = 'dreamsofart',
  DREAMSOFART_INPAINT = 'dreamsofartinpaint',
  CHATUNREAD = 'chatunread', // supabase_hub remove this when merging feature
  BATCH_COMPLETE = 'batchcomplete',
}
